import { IUser } from 'types/entities';
import { EntityService } from '../entity.service';


class UsersService extends EntityService<IUser> {
  readonly entityName = 'user';
}

export default new UsersService();
